export const buildConfirmAppointmentParams = ({ turn, patient, auth }) => ({
  clinica: turn?.idClinica || turn?.clinica,
  direccionClinica: turn?.direccion,
  idEspecialidad: turn?.idEspecialidad,
  nombreEspecialidad: turn?.nombreEspecialidad || turn?.nombre,
  idProfesional: turn?.idProfesional,
  nombreProfesional: turn?.nombreProfesional,
  idObraSocial: patient?.idObraSocial || patient?.obraSocial?.id,
  coberturaMedica:
    patient?.coberturaMedica ||
    patient?.obraSocial?.label ||
    patient?.obraSocial?.name ||
    patient?.obraSocial?.nombre ||
    '',
  plan:
    patient?.planLineaCartilla ||
    patient?.plan?.label ||
    patient?.plan?.name ||
    patient?.plan?.nombre ||
    '',
  idPlan: patient?.idPlan || patient?.plan?.id,
  idPaciente: patient?.idPaciente || patient?.pacienteERID,
  idSistema: '',
  fechaHora: turn?.fechaTurnoDateTime,
  nroCobertura: patient?.nroCobertura,
  nroAfiliado: patient?.nroAfiliado || patient?.credencial,
  nombreCompletoPaciente:
    patient?.nombreApellido || `${patient?.nombres || ''} ${patient?.apellidos || ''}`.trim(),
  nombrePaciente: patient?.nombres,
  nroDocumento: patient?.numeroDocumento || patient?.nroDocumento || patient?.documento,
  esVideoconsulta: false,
  idTurno: turn?.idTurno,
  Mail: auth?.email || patient?.mail || '',
  durationMinutes: turn?.durationMinutes || 0
})
